import Clock from './clock';

export default Clock;
